
import { MapLocation } from '@/types/location';

// DEN Gym Locations
export const denGyms: MapLocation[] = [
  {
    id: 14001,
    name: "DEN Gym - Jeddah (Al Bassaten)",
    type: "Gym",
    devices: 3,
    coordinates: [21.673405536941335, 39.1207860202411],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-45",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
